import { render, staticRenderFns } from "./CopyMultipleDocuments.vue?vue&type=template&id=6a709941&scoped=true"
import script from "./CopyMultipleDocuments.vue?vue&type=script&lang=js"
export * from "./CopyMultipleDocuments.vue?vue&type=script&lang=js"
import style0 from "./CopyMultipleDocuments.vue?vue&type=style&index=0&id=6a709941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a709941",
  null
  
)

export default component.exports